// extracted by mini-css-extract-plugin
export var active = "themeToggle-module--active--a90e3";
export var toggleButton = "themeToggle-module--toggleButton--4e20e";
export var toggleIcon = "themeToggle-module--toggleIcon--2812b";
export var toggleIconText = "themeToggle-module--toggleIconText--bf0a7";
export var toggleText = "themeToggle-module--toggleText--d8b14";